<script>

export default {
  name: 'CarList',

  props: {
    cars: {
      type: Array
    },

    selectedCarSection: {
      type: Object
    }
  }
}
</script>

<template>
  <div class="row" v-if="cars">
    <div class="columns">
      <h1>{{ $t('cars.title') }}</h1>

      <car v-for="car in cars" :key="car.id" :car="car" :selectedCarSection="selectedCarSection"></car>
    </div>
  </div>
</template>

<style lang="scss" scoped>
h1 {
  color: $black;
  text-align: center;
  font-size: rem-calc(60);
  @include breakpoint(medium down) {
    font-size: rem-calc(30);
    line-height: rem-calc(30);
  }
  @include breakpoint(small only) {
    font-size: rem-calc(25);
    line-height: rem-calc(25);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CarList.vue